import React, { FC, useRef, useState } from "react";
import {
  AddMembersIcon,
  ArrowTop,
  DescriptionIcon,
  InitiatorIcon,
  IntervalIcon,
  MeetingUrl,
  OuterMembersIcon,
  RoomsIcon,
} from "@components";
import {
  Formats,
  IMeeting,
  Intervals,
  getUserNameLastName,
  hoursFormat,
  monthsInGenitiveCase,
  setClass,
  useOutsideClick,
  weekDaysLong,
} from "@utils";
import { format } from "date-fns";
import { MeetingDetailedInformationMembersList } from "./MeetingDetailedInformationMembersList";
import { Member } from "./ListItems/Member";
import { OuterMember } from "./ListItems/OuterMember";
import "../../../styles/components/meetingDetailedInformationModal.scss";

interface IMeetingDetailedInformation {
  meeting: IMeeting;
  offset: number;
}

export const MeetingDetailedInformation: FC<IMeetingDetailedInformation> = ({
  meeting,
  offset,
}) => {
  const [showMembers, setShowMembers] = useState(false);
  const [showOuterMembers, setShowOuterMembers] = useState(false);
  const innerMemberListRef = useRef<HTMLDivElement>();
  const outerMemberListRef = useRef<HTMLDivElement>();
  const left = innerMemberListRef.current?.offsetLeft - 2;
  const top = {
    inner: innerMemberListRef.current?.offsetTop + 20,
    outer: outerMemberListRef.current?.offsetTop + 20,
  };
  const bottom = {
    inner: innerMemberListRef.current?.offsetTop,
    outer: outerMemberListRef.current?.offsetTop,
  };

  const onCloseOuter = () => setShowOuterMembers(false);
  const onCloseInner = () => setShowMembers(false);
  const onSwitchOuter = () => setShowOuterMembers((prev) => !prev);
  const onSwitchInner = () => setShowMembers((prev) => !prev);
  const dayNumber = meeting.startDate.getDay();
  const day = dayNumber === 0 ? weekDaysLong[6] : weekDaysLong[dayNumber - 1];
  const date = meeting.startDate.getDate();
  const month =
    monthsInGenitiveCase[meeting.startDate.getMonth()].toLowerCase();
  const getMemberConfirmation = (id: number) =>
    meeting.outerMemberConfirmation?.find((elem) => elem.memberId === id);

  const exceptionForOuterMembers = useRef<HTMLDivElement>();
  const exceptionForInnerMembers = useRef<HTMLDivElement>();
  const outerMembersRef = useOutsideClick(
    onCloseOuter,
    exceptionForOuterMembers
  );
  const innerMembersRef = useOutsideClick(
    onCloseInner,
    exceptionForInnerMembers
  );

  return (
    <>
      <div className="block">
        <div
          className="color"
          style={{ backgroundColor: `${meeting.calendarColor}` }}
        />
        <div className="name-date-text">
          <div className="name-text" title={meeting.meetingName}>
            {meeting.meetingName}
          </div>
          <div className="small-text">
            {`${day}, ${date} ${month} ${format(
              meeting.startDate,
              hoursFormat
            )} - ${format(meeting.endDate, hoursFormat)}`}
          </div>
        </div>
      </div>
      {meeting.intervalType && meeting.intervalType !== "WITHOUT_REPEAT" && (
        <div className="block small-text">
          <IntervalIcon divClassName="icon" />
          {
            Intervals.find(
              (interval) => interval.value === meeting.intervalType
            ).name
          }
        </div>
      )}
      {meeting.calendarId === -1 && (
        <div
          className="block small-text"
          onClick={onSwitchInner}
          ref={exceptionForInnerMembers}
        >
          <AddMembersIcon divClassName="icon" />
          <div ref={innerMemberListRef}>Участники</div>
          <ArrowTop
            divClassName={setClass(
              "members-arrow",
              !showMembers && "reverse",
              "clickable"
            )}
          />
        </div>
      )}
      {/* {meeting.calendarId === -1 && meeting.outerMembers.length !== 0 && (
        <div className="block small-text" onClick={onSwitchOuter} ref={exceptionForOuterMembers}>
          <OuterMembersIcon divClassName="icon" />
          <div ref={outerMemberListRef}>Внешние пользователи</div>
          <ArrowTop
            divClassName={setClass('members-arrow', !showOuterMembers && 'reverse', 'clickable')}
          />
        </div>
      )} */}
      {meeting.description && meeting.description !== "" && (
        <div className="block small-text">
          <DescriptionIcon divClassName="icon" />
          <div className="hidden-text">{meeting.description}</div>
        </div>
      )}
      {meeting.format === Formats.OFFLINE && meeting.room && (
        <div className="block small-text">
          <RoomsIcon divClassName="icon" />
          {`${meeting.room.cabinetNumber} ${meeting.room.conferenceTitle}`}
        </div>
      )}
      {meeting.format === Formats.ONLINE && meeting.link && (
        <div className="block small-text">
          <MeetingUrl divClassName="icon" />
          <a
            className="meeting-url hidden-text"
            href={meeting.link}
            target="_blank"
            rel="noreferrer"
          >
            {meeting.link}
          </a>
        </div>
      )}
      <div className="block small-text">
        <InitiatorIcon divClassName="icon" />
        {getUserNameLastName(meeting.initiator.fullName)}
      </div>
      {showMembers && (
        <MeetingDetailedInformationMembersList
          left={left}
          top={top.inner}
          bottom={bottom.inner}
          ref={innerMembersRef}
        >
          {meeting.members.map(
            (member) =>
              member && (
                <Member //TODO: ЗДЕСЬ Я ДОБАВИЛ ПРОВЕРКУ НА УВОЛЕННОГО СОТРУДНИКА
                  member={member}
                  meetingConfirmation={meeting.meetingConfirmation}
                  initiator={meeting.initiator}
                  offset={offset}
                />
              )
          )}
        </MeetingDetailedInformationMembersList>
      )}
      {/* {showOuterMembers && (
        <MeetingDetailedInformationMembersList
          left={left}
          top={top.outer}
          bottom={bottom.outer}
          ref={outerMembersRef}
        >
          {meeting.outerMembers.map((member) => (
            <OuterMember outerMember={member} outerConfirmation={getMemberConfirmation(member.id)}/>
          ))}
        </MeetingDetailedInformationMembersList>
      )} */}
    </>
  );
};
